import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardHeader, Col, Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchWebCountries } from '../../actions/web-countries';
import DataTable from '../../components/data-table';

const COLUMNS = [
  { id: 'id', label: 'ID', link: true },
  { id: 'name_en', label: 'English Name', link: true },
  { id: 'name_fr', label: 'French Name' },
  { id: 'name_ar', label: 'Arabic Name' },
  { id: 'country.name', label: 'Original Country', sortable: false },
  { id: 'ISOcountryCode', label: 'ISO Country Code' },
  { id: 'timezone', label: 'Timezone Offset' },
  { id: 'enabled', label: 'Enabled' },
];

const WebCountries = (props) => {
  const { getWebCountries } = props;
  return (
    <div className="animated fadeIn">
      <Row>
        <Col xl={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col lg={4}>Web Countries</Col>
                <Col lg={8} style={{ textAlign: 'right' }}>
                  <Button href="/#/web-countries/new" color="success" size="sm">New</Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <DataTable
                resource="webCountries"
                urlSchema="web-countries"
                dataSource={getWebCountries}
                columns={COLUMNS}
                {...props}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

WebCountries.propTypes = {
  getWebCountries: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  webCountries: PropTypes.arrayOf(PropTypes.object),
};

WebCountries.defaultProps = { webCountries: [] };

const mapStateToProps = ({ webCountries }) => ({
  loading: webCountries.loading,
  webCountries: webCountries.items,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getWebCountries: sort => fetchWebCountries(sort),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WebCountries);
